module.exports = __webpack_public_path__ + "img/Weilin Industrial Equipment Visual Inspection Software V1.0.f049e65f.jpg";